import {inject, InjectionToken, LOCALE_ID} from "@angular/core";

export const LOCALE_DATE_FORMAT = new InjectionToken<string>('locale date format', {
  providedIn: 'any',
  factory: () => {
    const LOCALE = inject(LOCALE_ID);
    return LOCALE === "en-US" ? 'mm/dd/yyyy HH:mm' : 'dd/mm/yyyy hh:mm'
  }
});
